/*
 *
 *  Cart
 *  contains basic js for the cart page
 *  !! Created by Charlotte on 29/08/2017
 *
 */
import '../../cart.js';

$(document).ready(function () {
    /** CART.TPL **/
    // Submit button
    $('.proceed').click(function () {
        // If the option 'I don't have an account' is selected, send the user directly to the register page instead of the intermediate login page
        let memberAccountHidden = $('div[data-type="check-account"]').hasClass('d-none');
        let selectedOption = $('input[name^="optMemberAccount"]:checked').val();
        if(!memberAccountHidden && selectedOption === "N"){
            document.location = strPath + strLang + '-' + strBdLang + '/cart-data';
        } else {
            document.location = strPath + strLang + '-' + strBdLang + '/cart-login';
        }
    });

    /** CART/CART-TABLE.TPL **/
    var blnCheckStock = false;
    if (WebsiteSettingBlnCheckStockAddCart && WebsiteSettingBlnUseStock && WebsiteSettingIntProductStockType == 2) {
        blnCheckStock = true;
    }

    // Enter only numeric values in 'quantity' fields
    $('.cart-table table input[type="text"]').each(function () {
        $(this).numeric();
    });

    // When you go out of the field 'quantity' (input field) => update quantity in cart (session)
    $('.cart-table table input[id^=qty]').blur(function () {
        CartUpdateCart($(this), blnCheckStock, blnMemberDiscount);
    });

    // When you enter in the field 'quantity' (input field) => update quantity in cart (session)
    $('.cart-table table input[id^=qty]').keypress(function (e) {
        // Enter key
        if (e.keyCode == 13) {
            CartUpdateCart($(this), blnCheckStock, blnMemberDiscount);
            return false;
        }
    });

    $('.cart-table table input[type="text"]').next().on('click', function () {
        $(this).addClass('hide');

        setTimeout(function () {
                $('.cart-table table input[type="text"]').next().removeClass('hide');
            },
            350);
    });

    // When you go out of the field 'quantity' (select box) => update quantity in cart (session)
    $('.cart-table table select[id^=selQty]').change(function () {
        if ($(this).val() == 0) {
            // Click on 'more' (in quantity field) => show input field
            $(this).parent().find('.qty-text').removeClass('d-none');
            $(this).parent().find('.qty-select').addClass('d-none');
        } else {
            // Update quantity in cart (session)
            var objInput = $(this).parent().find('input[id^=qty]');
            objInput.val($(this).val());

            CartUpdateCart(objInput, blnCheckStock, blnMemberDiscount);
        }
    });

    // Remove the product from the cart
    $('a.delete, a.delete-mobile').click(function () {
        // Check if not clicked twice (or more) on the link
        if (!$(this).hasClass('busy')) {
            $(this).addClass('busy');
            var intCartKey = $(this).data('key');
            if (intCartKey != "") {
                RemoveFromCart(intCartKey);
            }
        }

        return false;
    });


    /** CART/DISCOUNTCODE.TPL **/
    // Show block 'Your discount code' after clicking on the link 'Fill in your discount code'
    $('a.show-discount-code').click(function () {
        // Hide link
        $('.discount-start').addClass('d-none');
        // Show discount code input field
        $('.discount-end').removeClass('d-none');
        // Focus on input field
        $('input#txtDiscountCode').focus();

        return false;
    });

    // Validate discount code
    AddDiscountCode();

    // Validate giftcard code
    // AddGiftCardCode();

    // Remove discount code
    RemoveDiscountCode();

    if (WebsiteSettingBlnUseGiftCards) {
        // Remove giftcard code
        RemoveGiftCardCode();
    }


    /** CART/DELIVERYCHOICE.TPL**/
    if (blnShowDeliveryOptionsInCart) {
        if (WebsiteSettingBlnCartPickUpProducts) {
            // Click on radio button 'Delivery on address' or 'Pick up'
            $('input[name=\'optDeliveryMainOption\'], input[name=\'optPickUpPoint\'], input[name^=\'optDeliveryService\']').change(function () {

                // Get selected radio buttons
                var objDeliveryMainOption = $('input[name=\'optDeliveryMainOption\']:checked');
                var objPickUpPoint = $('input[name=\'optPickUpPoint\']:checked');
                var objDeliveryService = $('input[name^=\'optDeliveryService\']:checked');

                // Save choice for delivery or pickup in session + pick up point
                $.post(strAjaxPath + 'cart/save-delivery-main-option.php',
                    'intDeliveryMainOption=' + $(objDeliveryMainOption).val() +
                    '&intPickUpPoint=' + (objPickUpPoint.length ? objPickUpPoint.val() : -1) +
                    '&deliveryService=' + (objDeliveryService.length ? objDeliveryService.val() : -1),
                    function (arrObjecten) {
                        if (objDeliveryMainOption.val() == 1) {
                            // Pickup => show pick up points
                            $('#pick-up-points').removeClass('d-none');
                            $('#deliveryinfo').removeClass('d-none');
                            $('#select-country').addClass('d-none');
                            $('#delivery-services').addClass('d-none');

                            // Update shipping costs (= free)
                            UpdateShippingCosts('intUseTransport=0');
                        } else {
                            // Home delivery => hide pick up points
                            $('#select-country').removeClass('d-none');
                            $('#pick-up-points').addClass('d-none');
                            $('#deliveryinfo').addClass('d-none');
                                $('#delivery-services').removeClass('d-none');

                            // Update shipping costs
                            UpdateShippingCosts('strCountryCode=' + $('select#selCountry').val());
                        }
                });
            });

            let countrySelect = $('select#selCountry');
            countrySelect.change(function () {
                if (countrySelect.val() == 'BE') {
                    $('#delivery-services').removeClass('d-none');
                } else {
                    $('#delivery-services').addClass('d-none');
                }
            });
        }

        // Update shipping costs when changing the country (+ change deliverytypes if necessary)
        if ($('select#selCountry').closest('div').css('display') != 'none') {
            UpdateTransportOnCountryChange();
        }
    }

    // CUSTOM
    // When opening popup for login (choosing membership)
    $('#modalLogin').on('show.bs.modal', function (event) {
        var button = $(event.relatedTarget); // Button that triggered the modal
        var modal = $(this);

        // Change title login popup
        modal.find('#modal-title-login').text(button.data('labelaccount'));

        // Login validate
        FormValidateLogin($('form#frmLogin'), 'login');
    });

    // When clicking in popup for memberships on the button 'Become member' for VIP
    $('a[data-type="choose-membership"]').click(function () {
        // Click on radio button from this membership in cart
        $('input[name="optMembership"][data-group="' + $(this).data('group') + '"]').click();
        /*// Save choice in session
        $.post(strAjaxPath + 'membership/save-membership.php', 'groupno=' + $(this).data('group'), function (data) {
            // Check if membership was added to cart
            if (data.value == 1) {
                // Reload page
                document.location.reload();
            }
        }, 'json');

        // Add membership to cart
        $.post(strAjaxPath + 'membership/update-membership-cart.php', 'groupno=' + $(this).data('group'), function (data) {
            // Check if membership was added to cart
            if (data.value == 1) {
                // Go to cart
                document.location = strPath + strLang + '/cart';
            }
        }, 'json');*/
    });

    // Click on a membership
    $('input[name="optMembership"]').change(function () {
        if (!$(this).hasClass('active')) {
            // Save choice in session
            $.post(strAjaxPath + 'membership/save-membership.php', 'groupno=' + $(this).val(), function (data) {
                // Check if membership was added to cart
                if (data.value == 1) {
                    // Reload page
                    document.location.reload();
                }
            }, 'json');

            // Add/remove membership to/from cart
            $.post(strAjaxPath + 'membership/update-membership-cart.php', 'groupno=' + $(this).val(), function (data) {
                // Check if membership was added to cart
                if (data.value == 1) {
                    // Reload page
                    document.location.reload();
                }
            }, 'json');

            $(this).addClass('active');
        }
    });

    InitViewSelect();

    // Change bundle transport (for pre-orders)
    $('input[name="optBundleTransport"]').change(function(){
        // Save choice in session
        $.post(strAjaxPath + 'cart/save-bundle-transport.php', 'bundle=' + $(this).val(), function (data) {
            // Replace transport and total prices
            $('#cart-transport-price').html(data.strTransport);
            if ($('#cart-vat-price').length){
                $('#cart-vat-price').html(data.strVat);
            }
            $('#cart-total-price').html(data.strTotal);
        }, 'json');
    });
});

function InitViewSelect() {
    // Update view
    $('button[data-id="view"]').click(function () {
        // Save sortorder in session
        $.post(strAjaxPath + 'shop-view.php', 'value=' + $(this).attr('data-view'), function () {
            // Reload cart
            document.location.reload();
        }, 'json');
        return false;
        },
    );
}
